<template>
  <div class="uk-padding">
    <div class="uk-container uk-container-small" style="background: transparent">
      <div  id="modal_bg" class="uk-modal-container" uk-modal>
        <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical" style="text-align: center; background: transparent">
          <div style="background-color: white; padding: 30px; border-radius: 5px">
            <div class="uk-text-center">
              <h2 class="uk-text-primary"> <span uk-icon="icon: info; ratio: 2"></span> Notice</h2>
            </div>

            <div class="uk-text-lead">
              Northern Caribbean University advises students that ALL classes will be held virtually today.
              Non-essential workers are also advised to work from home, but essential personnel are required to
              report on campus today. The University Administration encourages all students and workers to monitor
              advisories from the ODPEM and the Met Service.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
export default {
  name: "adRow",
  mounted() {
    UIkit.modal("#modal_bg").show();
  }
}
</script>

<style scoped>
@media screen and (min-width: 320px){
  #modal_bg{
    background: transparent;
  }
  img{
    max-width: 250px;
    max-height: 250px;
    width: auto;
    height: auto;
  }
}

@media screen and (min-width: 600px){
  img{
    max-width: 500px;
    max-height: 500px;
    width: auto;
    height: auto;
  }
}
@media screen and (min-width: 900px){
  img{
    max-width: 500px;
    max-height: 500px;
    width: auto;
    height: auto;
  }
}
@media screen and (min-width: 1200px){
  img{
    max-width: 900px;
    max-height: 900px;
    width: auto;
    height: auto;
  }
}

</style>
